import { useDispatch, useSelector } from "react-redux";

import { colorsPalettes } from "@similarweb/styles";
import { Button, Modal } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { AI_AGENT_MEETING, AI_AGENT_MEETING_ROOT } from "app/pages/sales-intelligence/constants/routes";
import { closeRedirectModal } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/download-pdf/store/action-creators";
import {
    selectIsRedirectModalOpen,
    selectRedirectModalCompanyName,
} from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/download-pdf/store/selectors";
import { AI_AGENT_PRICE_PER_RECORD } from "app/pages/sales-intelligence/modules/quota/constants";
import { useQuotaGuard } from "app/pages/sales-intelligence/modules/quota/hooks/useQuotaGuard";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const RedirectBriefModal = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(selectIsRedirectModalOpen);
    const domain = useSelector(selectRedirectModalCompanyName);
    const { isBlocked, isLoading } = useQuotaGuard(AI_AGENT_PRICE_PER_RECORD);

    const handleSubmit = () => {
        dispatch(closeRedirectModal());
        if (domain) {
            void proNavigator.go(AI_AGENT_MEETING, { domain, id: undefined, autogenerate: true });
        } else {
            void proNavigator.go(AI_AGENT_MEETING_ROOT);
        }
    };

    const handleCancel = () => {
        dispatch(closeRedirectModal());
    };

    const handleGotIt = () => {
        dispatch(closeRedirectModal());
        void proNavigator.go(AI_AGENT_MEETING_ROOT);
    };

    return (
        <Modal
            isOpen={Boolean(isOpen && !isLoading)}
            onRequestClose={handleCancel}
            customStyles={{
                content: {
                    width: "400px",
                },
            }}
        >
            <Flex
                flexDirection="column"
                width="400px"
                padding="0 24px"
            >
                <Text
                    fontVariant="h5"
                    color={colorsPalettes.carbon[500]}
                    padding="20px 0"
                >
                    {translate("si.pages.ai_agent.meeting.redirect_brief_modal.title")}
                </Text>
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[400]}
                    padding="16px 0"
                >
                    {isBlocked
                        ? translate("si.pages.ai_agent.meeting.redirect_brief_modal.out_of_credits_text_1")
                        : translate("si.pages.ai_agent.meeting.redirect_brief_modal.text_1")}
                </Text>
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[400]}
                    padding="4px 0 20px"
                >
                    {isBlocked
                        ? translate("si.pages.ai_agent.meeting.redirect_brief_modal.out_of_credits_text_2")
                        : translate("si.pages.ai_agent.meeting.redirect_brief_modal.text_2")}
                </Text>
                <Flex
                    alignItems="center"
                    justifyContent="flex-end"
                    gap="8px"
                    padding="12px 0"
                >
                    {isBlocked ? (
                        <Button
                            type="primary"
                            onClick={handleGotIt}
                            data-automation="redirect-modal-got-it-button"
                        >
                            {translate("si.common.got-it")}
                        </Button>
                    ) : (
                        <>
                            <Button
                                type="flat"
                                onClick={handleCancel}
                                data-automation="redirect-modal-cancel-button"
                            >
                                {translate("si.common.button.cancel")}
                            </Button>
                            <Button
                                type="primary"
                                onClick={handleSubmit}
                                data-automation="redirect-modal-generate-button"
                            >
                                {translate("si.pages.ai_agent.meeting.redirect_brief_modal.generate_new")}
                            </Button>
                        </>
                    )}
                </Flex>
            </Flex>
        </Modal>
    );
};
